import { ApiClientFactory } from './ApiClientFactory';

const clientFactory = new ApiClientFactory;

export const BaseClient = {
	init() {
		return clientFactory.get('dashboard/init');
	},

	userLanguage($code) {
		return clientFactory.get('dashboard/user-language?code=' + $code);
	}
};